<template>
  <div class="wrap">
    <div class="top">
      <img src="@assets/imgs/ebike/0.png" class="topbg" />
      <div class="toplogo">
        <img src="@assets/imgs/ebike/GOWOW Logo hei.png" />
        <br />
        <span v-if="!isCN"> Electric Dirt Bike</span>
        <ul class="title" v-if="isCN">
          <li>格</li>
          <li>物</li>
          <li>电</li>
          <li>动</li>
          <li>摩</li>
          <li>托</li>
          <li>车</li>
        </ul>
      </div>
    </div>
    <ul class="text" ref="textw">
      <li>{{ $t("ebike.你好！我们是格物电动摩托车") }}</li>
      <li>
        {{ $t("ebike.“敢于颠覆传统，改善交通与环境，让人们享受出行”，") }}
      </li>
      <li>
        {{ $t("ebike.是格物电动摩托车的使命，") }}
      </li>
      <li>
        {{ $t("ebike.我们致力于为骑行者打造更安全、更便捷、") }}
      </li>
      <li>
        {{ $t("ebike.更有趣的智能电动摩托车。") }}
      </li>
      <li>
        {{ $t("ebike.我们坚持核心硬件自研，") }}
      </li>
      <li>
        {{ $t("ebike.并在电机、电控、电池芯、") }}
      </li>
      <li>
        {{ $t("ebike.前后避震、智能操作模式") }}
      </li>
      <li>
        {{ $t("ebike.等关键技术领域取得了技术自研成果，") }}
      </li>
      <li>
        {{ $t("ebike.我们坚持自建制造基地为唯一的生产模式，") }}
      </li>
      <li>
        {{ $t("ebike.并在自建供应链体系，保障核心零部件的供应。") }}
      </li>
    </ul>
    <div class="center">
      <p class="table">{{ $t("ebike.核心技术自研") }}</p>
      <ul>
        <li>
          <img src="@assets/imgs/ebike/4.png" />
          <p>{{ $t("ebike.驱动系统") }}</p>
        </li>
        <li>
          <img src="@assets/imgs/ebike/5.png" />
          <p>{{ $t("slides.电机") }}</p>
        </li>
        <li>
          <img src="@assets/imgs/ebike/6.png" />
          <p>{{ $t("slides.电控") }}</p>
        </li>
      </ul>
      <ul>
        <li>
          <img src="@assets/imgs/ebike/1.png" />
          <p>{{ $t("slides.前避震") }}</p>
        </li>
        <li>
          <img src="@assets/imgs/ebike/2.png" />
          <p>{{ $t("slides.后避震") }}</p>
        </li>
        <li>
          <img src="@assets/imgs/ebike/3.png" />
          <p>{{ $t("ebike.智能操作模式") }}</p>
        </li>
      </ul>
    </div>
    <div class="bottom">
      <img src="@assets/imgs/ebike/starry sky.png" />
      <ul>
        <li class="title">{{ $t("ebike.设计能力") }}</li>
        <li>{{ $t("ebike.未来时尚设计") }}</li>
        <li>
          {{ $t("ebike.年轻时尚的设计团队，打造未来感十足的电动摩托车") }}
        </li>
        <li>
          {{
            $t(
              "ebike.“银河”家族设计语言造型设计，并将设计语言定义为未来时尚设计"
            )
          }}
        </li>
        <li>
          {{ $t("ebike.星辰，指引探索者们方向，赋予人们无垠的想象") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      textw: "50vw",
    };
  },
  mounted() {},
  computed: {
    ...mapState(["lang"]),
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
.wrap {
  position: relative;
  img {
    vertical-align: top;
  }
  .top {
    position: relative;
    width: 100vw;
    height: auto;
    .topbg {
      width: 100vw;
      vertical-align: top;
    }
    .toplogo {
      width: 100vw;
      top: 30%;
      position: absolute;
      text-align: center;
      z-index: 10;
      img {
        width: 22vw;
        margin: 0;
        padding: 0;
      }
      span {
        font-size: 50px;
        font-weight: 400;
        font-family: PingFang-SC-Medium;
        // font-style: italic;
      }
      .title {
        width: 20vw;
        display: flex;
        justify-content: space-evenly;
        margin: 0 auto;
        list-style: none;
        font-size: 25px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 50px;
      }
    }
  }
  .text {
    width: 70%;
    margin: 30px auto;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 300;
    line-height: 50px;
    font-size: 19px;
  }
  .center {
    width: 100vw;
    height: auto;
    background-color: #eaeff4;
    padding: 3vw 0 1vw 0;
    .table {
      text-align: center;
      font-size: 38px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 100px;
    }
    ul {
      display: flex;
      justify-content: center;
      li {
        margin: 2vw 1vw;
        img {
          width: 30vw;
        }
        p {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 300;
          line-height: 40px;
          padding-left: 10px;
          text-align: center;
        }
      }
    }
  }
  .bottom {
    width: 100vw;
    position: relative;
    ul {
      position: absolute;
      top: 35%;
      color: white;
      width: 100vw;
      text-align: center;
      height: auto;
      li {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 300;
        line-height: 40px;
      }
      .title {
        font-size: 50px;
        font-family: PingFang SC;
        font-weight: 300;
        line-height: 100px;
      }
    }
    img {
      width: 100vw;
    }
  }
}
</style>
